module.exports = __webpack_public_path__ + "img/learnReason-banner2.67dff8f0.png";